module.exports = __webpack_public_path__ + "static/img/2.6838e916.jpg";